import type { BundleDetails } from "./bundle";

export type Category = {
	id: string;
	name: string;
	icon: string;
	tenantId?: string;
	hasState?: boolean;
};
export type StateDetails = {
	name: string;
	code: string;
	alias?: string;
};
export type ExamContext = {
	id: string;
	examId: number;
	name: string;
	icon: string;
	isActive: boolean;
	created: string;
	relatedExams?: string[];
	state?: StateDetails;
	updated: string;
	numericId: number;
	category: Category[];
	studyPackCollection: number[];
	practiceTestCollection: number[];
	tenantId: string;
	bundles: BundleDetails[];
};
export type ExamMetaData = {
	isActiveExam: boolean;
	examDate: string;
};
export type ExamDetails = {
	id: string;
	exam: ExamContext;
	metadata: ExamMetaData;
};
